import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import PurchaseService from "../services/Purchase";
import Loader from "../component/Loader";
import OtherService from "../services/Other";
// import PrimaryGradientButton from './PrimaryGradientButton'
// import PrimaryGradientButton from '../component/PrimaryGradientButton'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import ConfirmationModal from '../component/ConfirmationModal'

const AllEstimate = () => {
  const [loading, setLoading] = useState(true);
  const [purchaseList, setIsPurchaseList] = useState([]);
  // model on off
  const [isPanVerifyModalOpen, setIsPanVerifyModalOpen] = useState(false)
  const [isPanUploadModal, setIsPanUploadModal] = useState(false);
  const [show, setShow] = useState(false);
  const [idvalue, setIdvalue] = useState("");

  function convertTimestampToDate(timestamp) {
    const date = new Date(timestamp);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
}

function alertShow(value) {
  setIsPanVerifyModalOpen(true)

  setIdvalue(value)
// alert(value)

}

  const approveEstimatee  = async (value) => {
    const token = localStorage.getItem("access_token");
    
    const paylode = {
      "status":"Approved",
      "estimationId":value,
      
  
  }
  
try{
  const delresult = await OtherService.approveEstimate(paylode,token);

if(delresult.data=="Approved successflly")
alert("Approved successflly")
else{
  alert("Approved Not successflly")
}

}
catch (e) {
  console.error("Error");
}

}

const handleOptionSelection = (response) => {
  if (response == 'Yes') {
      setIsPanVerifyModalOpen(false)
      setIsPanUploadModal(true)
      setShow(true)
      approveEstimatee(idvalue)
  }
  else if (response == 'No') {
      setIsPanVerifyModalOpen(false);
      // navigate(`/address-list`);
  }
}

  useEffect(() => {
    const PurchaseListFetchData = async () => {
      try {
        const token = localStorage.getItem("access_token");

        // OtherService.taskList
        const responsePurchaseList = await OtherService.allestimatee(token);
        //  const responsePurchaseList = await PurchaseService.myPurchaseItems(token)
        const filteredData = responsePurchaseList.data.map((item, index) => {
          let statusElement;

          if (item.task_type == "ekyc_document_upload_pending") {
            statusElement = <span className="pendingTxt">Pending</span>;
          } else if (item.task_type == "ekyc_tso_document_approval_pending") {
            // statusElement = <span className='approvedTxt'>panding</span>;
            statusElement = <span className="pendingTxt">Pending</span>;
          }
          // else if (item.sale_status == 2) {
          //   statusElement = <span className='rejectedTxt'>Rejected</span>;
          // }

          const actionButtons = <div className='ordersButtonWrap d-flex justify-content-center'>

         
          { (
              <>
                   <div className='feedbackTrackOrderTxt' onClick={() =>alertShow(item.estimationId)}>
                      <PrimaryOutLineButton  outlinebuttonText="Approve" />
                      {/* */}
                      {/* <PrimaryOutLineButton  outlinebuttonText="Approve" /> */}
                  </div>
                 

                  <div className='trackOrderTxt' onClick={() => { alertShow(11) }}>
                      {/* <PrimaryGradientButton buttonText="Approve" /> */}
                      <span className='pendingTxt bg-danger px-4 py-2'>Delete</span>

                      
                  </div>

              </>
          )}
      </div>

          return {
            "Serial No": index + 1,
            // "ID NO": item.id,
            
            "Created Date":convertTimestampToDate(item.created_at) ,
            // Task: <div className="text-left">{item.task}</div>,
            // Task: <div className="text-left">"bjxcjxcjkxkcj"</div>,
            //  'Task Type':<b>{item.task_type}</b>
            // 'Tesk Type':<div className="text-left">{item.task_type}</div>,
            // Status: statusElement,
           'Area in Sqft': item.area_in_sqft,
           Grade:item.grade,
          //  Action : <PrimaryGradientButton onClick={() => approveEstimate(22)} buttonText='Approve Estimate' />,
          "Estimation id":item.estimationId,
           'Actions': actionButtons,
         

            // 'Quantity': item.tonnage_sold,
            // 'Description': item.product_description,
            // 'Purchase Date': item.sale_date,
            // 'Enrolled Date': formattedDateTime,
            // 'Status': statusElement
          };
        });
        setIsPurchaseList(filteredData);
        setLoading(false);
      } catch (e) {
        console.error("Error");
      }
    };
    PurchaseListFetchData();
  }, []);
  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion
        pageTitle="All Estimate"
        currentPageName="All Estimate"
      />
      <section className="padTop50">
        <Container>

          {
          isPanVerifyModalOpen==true?
 <ConfirmationModal
 page="eKYCResponse"
 onClick={handleOptionSelection}
 isModalOpen={isPanVerifyModalOpen}
 setIsModalOpen={setIsPanVerifyModalOpen}
 modalTitle="Are You Sure Want To Delete?" />
:
""

          }
      

          <Row>
            <Col>
              <ThemeTable data={purchaseList} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AllEstimate;
